module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.deadd05b.jpeg";